import { render } from "./refugee_verification_service.html?vue&type=template&id=51d230fc&external"
import script from "./refugee_verification_service.js?vue&type=script&lang=js&external"
export * from "./refugee_verification_service.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__